@if (isVisible && user) {
    <div class="fixed inset-0 w-screen h-screen overflow-y-auto bg-gray-500 text-slate-900 bg-opacity-70 z-[100] text-base cursor-default">
        <div class="flex items-center justify-center pt-20">
            <div #confirmationModal class="w-[400px] h-[225px] bg-slate-100 rounded shadow flex flex-col">
                <div class="p-2 flex flex-row bg-ponder-light text-slate-50 font-bold rounded-t shadow">
                    <div class="grow">
                        Delete User Confirmation
                    </div>
                    <div (click)="onClose()" class="stroke-faded-50 hover:stroke-white hover:cursor-pointer">
                        <svg class="pl-1 w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                            <title>Close</title>
                            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="closeSvgIcon" />
                        </svg>
                    </div>
                </div>
                @if (!deletionFailed) {
                    <div class="p-2 flex flex-col gap-4 grow overflow-y-auto">
                        <div>
                            Please confirm that you wish to delete this user.
                        </div>
                        <div class="font-bold">
                            Delete user '{{ user.user.username }}'?
                        </div>
                    </div>
                    <div class="p-2 flex flex-row gap-4 items-center align-middle justify-end">
                        @if (!isRunning) {
                            <button (click)="onClose()" class="p-2 w-20 bg-slate-50 hover:bg-white rounded-sm shadow">Cancel</button>
                            <button (click)="onConfirm()" class="p-2 w-20 text-slate-50 bg-red-700 hover:bg-red-500 rounded-sm shadow">Confirm</button>
                        } @else {
                            <busy-spin></busy-spin>
                        }
                    </div>
                } @else {
                    <div class="p-2 pt-4 flex flex-col gap-4 text-center align-middle grow">
                        <div class="font-bold">Uh oh! Something went wrong!</div>
                        <div>Please refresh the page and try again. If you continue experiencing problems, <a class="text-ponder-link hover:text-ponder-linkhover" href="/about#contact">please contact us</a>.</div>
                    </div>
                }
            </div>
        </div>
    </div>
}